// src/features/auth/hooks/useLogin.ts
import { useMutation } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { LoginData, LoginResponse } from '../types';
import { authApi } from '../api/authApi';

/**
 * Hook to handle login process
 * Uses AuthContext to manage authentication state
 */
export function useLogin() {
  const { login } = useAuth();

  return useMutation<LoginResponse, Error, LoginData>({
    mutationFn: async (data: LoginData) => {
      return await authApi.login(data);
    },
    onSuccess: (response) => {
      // Use AuthContext login method instead of localStorage
      login(response.token);
    },
    onError: (error) => {
      console.error('Login error:', error);
      // Error is handled in the component that uses this hook
    },
  });
}
